{
    "warning": "ATTENZIONE!",
    "message": "Non inserire o incollare codici che non conosci.\nL'utilizzo di questa console potrebbe consentire a utenti malintenzionati di assumere la tua identità e rubare le tue informazioni tramite un attacco chiamato Self-XSS."
}
